import React, {useState} from "react";
import loginBackground from "../../assets/img/background_login_transparent_small.png";
import {FormattedMessage} from "react-intl";
import * as UserService from "../../services/UserService";
import {validateEmail} from "../../util/common";
import {PATH} from "../../routes/routes";
import * as StorageService from "../../services/StorageService";
import {LOCALSTORAGE_ITEMS, USER_TYPES} from "../../util/Constants";
import backImg from "../../assets/img/icon_back.svg";
import {importAllProductsOrders} from "../../services/ProductService";
import {useLocation, useNavigate} from "react-router";


function Login() {
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const redirectUrlAfterLogin = query.get('redirect');
    const navigateTo = useNavigate();
    const visible = "visible";
    const hidden = "hidden";
    const [state, setState] = useState({
        loading: false,
        errorMsg: null,
        errorMsgPopup:null,
        forgotPasswordPopupStyle:hidden,
        confirmationResetPasswordPopupStyle:hidden,
        email: "",
        password: "",
        isSubmitBtnEnabled: true,
        forgotPasswordEmailInput: ""
    });



    const validateInputs = () => {
        if (state.email === null || state.email === "" || !validateEmail(state.email)) {
            return <FormattedMessage id="PleaseEnterAvalidEmail"/>
        } else if (state.password === null || state.password === "") {
            return <FormattedMessage id="PleaseEnterAvalidPassword"/>
        } else if (state.forgotPasswordEmailInputInput === null && state.forgotPasswordPopupStyle) {
            return <FormattedMessage id="PleaseEnterAvalidEmail"/>;
        } else {
            return null;
        }
    }

    const loginUser = async () => {
        const error = validateInputs();
        if (error) {
            setState({
                ...state,
                errorMsg: error
            })
            return;
        }


        if (!state.isSubmitBtnEnabled) {
            return;
        }
        setState({
            ...state,
            isSubmitBtnEnabled: false,
            loading: true,
        })


        const body = {
            "email": state.email.toLowerCase(),
            "password": state.password,
        }

        const response = await UserService.loginWithUserAndPassword(body);
        if (response.ok) {
            StorageService.setItem(LOCALSTORAGE_ITEMS.USER_INFO, JSON.stringify(response.data.user));
            StorageService.setItem(LOCALSTORAGE_ITEMS.USER_EMAIL, response.data.user.email);
            StorageService.setItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN, response.data.token);
            StorageService.setItem(LOCALSTORAGE_ITEMS.USER_TYPE, USER_TYPES.VERIFIED);

            const bodyForImportProducts = {
                 "user": response.data.user.email,
                "prevUser":StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL_ANONYMOUS)
            }
            await importAllProductsOrders(bodyForImportProducts).then(response=>{
                if (response) {
                    StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_EMAIL_ANONYMOUS);
                }

            });
            if (redirectUrlAfterLogin) {


                if (redirectUrlAfterLogin === "back") {
                    navigateTo(-1);
                }else{
                    navigateTo(redirectUrlAfterLogin);
                }
            }else{
                navigateTo(PATH.CREATE_RESERVATION);
            }

        } else {
            if (response.data.code === 403) {
                setState({
                    ...state,
                    errorMsg: <FormattedMessage id="Error.invalidCredentials"/>,
                    loading: false,
                })
            } else {
                setState({
                    ...state,
                    errorMsg: <FormattedMessage id="Error.genericError"/>,
                    loading: false,
                })
            }
        }
    }

    const handleOnChange = (e, input) => {
        if (input === "email") {
            setState({
                ...state,
                email: e.target.value
            })

        } else if (input === "password") {
            setState({
                ...state,
                password: e.target.value
            })
        }else if (input === "forgotPasswordEmailInputInput") {
            setState({
                ...state,
                forgotPasswordEmailInputInput: e.target.value
            })
        }
    }


    const toRegisterPage = (e) => {
        e.preventDefault();
        //TODO useNavigate with search params
        navigateTo({
            pathname:  PATH.REGISTER,
            search: "?redirect="+redirectUrlAfterLogin,
        });
    }

    const openForgotPasswordModal = () => {
        setState({
            ...state,
            forgotPasswordPopupStyle: visible
        })
    }

    const openConfirmationResetPasswordModal = () => {
        setState({
            ...state,
            forgotPasswordEmailInputInput:"",
            forgotPasswordPopupStyle: hidden,
            confirmationResetPasswordPopupStyle:visible,
            errorMsgPopup:null,
        })
    }
    const closeAllModals = () => {
        setState({
            ...state,
            forgotPasswordEmailInputInput:"",
            confirmationResetPasswordPopupStyle:hidden,
            forgotPasswordPopupStyle: hidden,
            errorMsgPopup:null,
        })
    }

    const sendRecoveryEmail = async () => {
        if (!validateEmail(state.forgotPasswordEmailInputInput)) {
            setState({
                ...state,
                errorMsgPopup: <FormattedMessage id="PleaseEnterAvalidEmail"/>,
                forgotPasswordEmailInputInput:"",
                loading: false,
            })
        }else{
            const body = {
                "email": state.forgotPasswordEmailInputInput,
            }
            const response = await UserService.recoverUserPassword(body);
            if (response.ok) {
                openConfirmationResetPasswordModal();
            } else {
                if (response.data.code === 404) {
                    setState({
                        ...state,
                        errorMsgPopup: <FormattedMessage id="Error.userDoesntExist"/>,
                        loading: false,
                    })
                }else{
                    setState({
                        ...state,
                        errorMsgPopup:  <FormattedMessage id="Error.genericError"/>,
                        loading: false,
                    })
                }
            }
        }
    }

    const goBack = () => {
        if (redirectUrlAfterLogin === "back") {
            navigateTo(-1);
        }else if (redirectUrlAfterLogin){
            navigateTo(redirectUrlAfterLogin);
        }else{
            navigateTo(-1)
        }

    }

    return (
        <div className="page-content without-actionsbar">
            <div className={state.confirmationResetPasswordPopupStyle+" modal-overlay "}
                 onClick={(e)=> closeAllModals()}
                 data-qa="login-page-close-all-modals-overlay">
            </div>

            <div className="modal forgot-pwd-modal">
                <div className="row">
                    <p className="modal-text"><FormattedMessage id="PleaseCheckYourEmailToRecoverPassword"/></p>
                </div>
                <div className="row buttons-row">
                    <a className="link" onClick={() => closeAllModals()}
                       data-qa="login-page-close-all-modals-btn">
                        <FormattedMessage id="Ok"/>
                    </a>
                </div>
                {state.errorMsgPopup != null ?
                    <>
                        <br/>
                        <div className="error-div full-width">
                            <p>&#9888;&nbsp;{state.errorMsgPopup}</p>
                        </div>
                    </>

                    : null
                }
            </div>



            <div className={state.forgotPasswordPopupStyle+" modal-overlay "} onClick={(e)=> closeAllModals()}>   </div>
            <div className="modal forgot-pwd-modal">
                <div className="row">
                    <div className="modal-title"><FormattedMessage id="EnterYourEmail"/></div>
                </div>

                <div className="form-group">
                    <div className="row">
                        <FormattedMessage id="Email" defaultMessage="Email">
                            {placeholder =>
                                <input
                                    className="input"
                                    type="email"
                                    onChange={e => handleOnChange(e, "forgotPasswordEmailInputInput")}
                                    maxLength={80}
                                    value={state.forgotPasswordEmailInputInput}
                                    placeholder={placeholder}
                                    autoComplete="off"
                                    id="forgot-pwd-email"
                                    data-qa="forgot-pwd-popup-email-input"
                                />
                            }
                        </FormattedMessage>
                    </div>
                </div>

                <div className="row buttons-row">
                    <a className="link" onClick={() => closeAllModals()}
                       data-qa="forgot-password-popup-cancel-btn"><FormattedMessage id="Cancel"/>
                    </a>
                    <a className="link" onClick={() => sendRecoveryEmail()}
                       data-qa="forgot-password-popup-recover-btn"><FormattedMessage id="Recover"/>
                    </a>
                </div>

                {state.errorMsgPopup != null ?
                    <>
                        <br/>
                        <div className="error-div full-width"
                             data-qa="login-page-forgot-pwd-popup-error-div">
                            <p>&#9888;&nbsp;{state.errorMsgPopup}</p>
                        </div>
                    </>

                    : null
                }

            </div>

            <div className="login-container">
                <a className="btn-back" onClick={goBack} data-qa="login-page-back-btn"><img alt="back button" src={backImg}/></a>
                <div className="login-container-top-img">
                    <img alt="login background" src={loginBackground} alt="login background"/>
                </div>
                <div className="login-container-content text-left">
                    <div className="login-container-content-top-text">
                        <FormattedMessage id="LoginToTakeAdvantage"/>
                    </div>
                    <div className="form-group">
                        <div className="row">
                            <label>{<FormattedMessage id="Email"/>}</label>
                            <FormattedMessage id="Email" defaultMessage="Email">
                                {placeholder =>
                                    <input
                                        className="input"
                                        type="email"
                                        onChange={e => handleOnChange(e, "email")}
                                        maxLength={80}
                                        // placeholder={placeholder}
                                        autoComplete="off"
                                        id="email"
                                        data-qa="login-page-email-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>

                        <div className="row">
                            <label>{<FormattedMessage id="Password"/>}</label>
                            <FormattedMessage id="Password" defaultMessage="Password">
                                {placeholder =>
                                    <input
                                        className="input"
                                        type="password"
                                        onChange={e => handleOnChange(e, "password")}
                                        maxLength={100}
                                        // placeholder={placeholder}
                                        autoComplete="user-pwd"
                                        id="pwd"
                                        value={state.password}
                                        data-qa="login-page-pwd-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>
                    </div>
                    <div className="row btn-row">
                        <button onClick={() => loginUser()}
                                className="btn btn-md btn-default uppercase"
                                data-qa="login-page-sign-in-btn">
                            <FormattedMessage id="SignIn"/></button>
                    </div>

                    <div className="row">
                        <a onClick={(e) => openForgotPasswordModal(e)}
                           className="link reset-password"
                           data-qa="login-page-open-reset-pwd-btn">
                            <FormattedMessage  id="ForgotPassword" defaultMessage="ForgotPassword"/>
                        </a>
                    </div>

                    <div className="row">
                        <button onClick={(e) => toRegisterPage(e)}
                                className="btn btn-md btn-default faded"
                                data-qa="login-page-go-to-register-page-btn">
                            <FormattedMessage id="CreateAccount" defaultMessage="CreateAccount"/></button>
                    </div>

                </div>

                {state.errorMsg != null ?
                    <div className="error-div"
                         data-qa="error-div">
                        <p>&#9888;&nbsp;{state.errorMsg}</p>
                    </div>
                    : null
                }


            </div>
        </div>

    );
}

export default Login;
